export function createLoader(rootEl, opts = {}) {
  const $ = jQuery;
  const cfg = {
    path: '',                
    mount: rootEl,         
    className: 'loading-animation',
    debug: false
  };

  Object.assign(cfg, opts);

  const $mount = $(cfg.mount);
  let $box = null;
  let instance = null;

  const log = (...a) => cfg.debug && console.debug('[Loader]', ...a);

  function ensureBox() {
    if ($box && $box.length && document.contains($box[0])) return $box;

    // Find existing .loading-animation under mount; otherwise create it
    $box = $mount.find(`.${cfg.className}`).first();
    if (!$box.length) {
      $box = $(`<div class="${cfg.className}" aria-hidden="true" style="display:none"></div>`);
      $mount.append($box);
      log('created .loading-animation under mount', $mount[0]);
    }

    // Make mount a positioning context; overlay the loader to cover the mount
    if ($mount.css('position') === 'static') $mount.css('position', 'relative');
 
    // Center Lottie nicely
    if ($box.css('display') === 'none') $box.css('display', 'none');
    $box.css('display'); // force style recalc
    $box.css('display', 'none'); // keep hidden until show()

    // Make sure flex centering is applied
    $box.css('display', 'none'); // retain hidden state
    $box.css({ display: 'none' });
    $box.css('display'); // noop to keep order

    // Apply flex on show() below; some themes reset display

    return $box;
  }

  function startLottie() {
    const api = (typeof window !== 'undefined' && window.lottie) ? window.lottie : (typeof lottie !== 'undefined' ? lottie : null);
    if (!api) {  return; }
    if (!cfg.path) {  return; }
    if (instance) {
      try { instance.play(); } catch (e) { log('lottie.play failed', e); }
      return;
    }
    try {
      instance = api.loadAnimation({
        container: $box[0],  // use .loading-animation as the container
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: cfg.path
      });
    } catch (e) {
      log('lottie.loadAnimation failed', e);
    }
  }

  return {
    show() {
      ensureBox();
      // Flex centering each time to avoid theme overrides
      $box.css({ display: 'flex'});
      startLottie();
      $mount.attr('aria-busy', 'true');
    },
    hide() {
      if ($box && $box.length) $box.hide();
      if (instance) { try { instance.pause(); } catch (e) { log('lottie.pause failed', e); } }
      $mount.removeAttr('aria-busy');
    },
    destroy() {
      if (instance) { try { instance.destroy(); } catch {} instance = null; }
      if ($box && $box.length) $box.remove();
      $box = null;
    }
  };
}